import i18n from "../../../../locales";
import { SagaIterator } from "redux-saga";
import { requester } from "../../../../libs/requester";
import { put, call, takeLatest } from "redux-saga/effects";
import { saveBanners } from "../../repository/actions";
import { links } from "../../../../utils/links";
import { createNotification } from "../../../../utils/createNotification";
import { setAppLoading } from "../../../app/repository/actions";

function* getBannersWorker(): SagaIterator {
  try {
    yield put(setAppLoading(true));
    const { data, isError, message } = yield call(
      requester.get,
      links.getBanners
    );
    if (isError) {
      createNotification({
        title: i18n.t("error"),
        message,
        type: "danger",
      });
    } else {
      yield put(saveBanners(data));
    }
  } catch (error) {
    console.error("getBannersWorker: ", error);
  } finally {
    yield put(setAppLoading(false));
  }
}

export function* getBannersWatcher() {
  yield takeLatest("@saga/GET_BANNERS", getBannersWorker);
}
